import { Loader2 } from 'lucide-react';
import { TextShimmer } from '@/components/ui/text-shimmer';
import finalCongratulations from '@/assets/finalCongratulations.png';

interface ProjectGroupStatusProps {
  isLoading: boolean;
}

function ProjectGroupStatus({ isLoading }: ProjectGroupStatusProps) {
  if (isLoading) {
    return (
      <div className="text-center space-y-4">
        <TextShimmer className="text-4xl font-bold">Processing </TextShimmer>
        <div className="w-48 h-48 mx-auto flex items-center justify-center">
          <Loader2 className="w-16 h-16 animate-spin text-primary" />
        </div>
        <h3 className="text-2xl font-semibold">Please wait</h3>
        <p className="text-muted-foreground">
          We&apos;re processing your data. This may take a moment.
        </p>
      </div>
    );
  }

  return (
    <div className="text-center p-6">
      <div className="max-w-3xl w-full space-y-6">
        {/* Congratulations Image */}
        <div className="w-[860px] max-w-full h-auto mx-auto animate-in fade-in zoom-in-95 duration-500 fill-mode-both motion-reduce:animate-none">
          <img
            src={finalCongratulations}
            alt="Congratulations"
            className="w-full h-auto"
          />
        </div>

        {/* Main Heading */}
        <h3 className="text-3xl font-semibold text-gray-800 animate-in fade-in slide-in-from-bottom-2 duration-500 delay-75 fill-mode-both motion-reduce:animate-none">
          Multi Workpiece has been submitted for Review 🎉
        </h3>

        {/* Review Information */}
        <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-500 delay-150 fill-mode-both motion-reduce:animate-none">
          <p className="text-gray-600 text-base leading-relaxed px-4">
            Each file is carefully reviewed by a human to ensure the highest
            quality and accuracy. This process helps identify any potential
            issues and guarantees that the final output meets the desired
            standards, providing the best experience for the user.
          </p>

          <p className="text-gray-700 font-medium">
            Your Multi Workpiece will be published once the review is done.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProjectGroupStatus;
